





























import Api from "./Api";
import {Component, Inject} from "vue-property-decorator";
import Routes from "../../../modules/Routes";
import {UserRoleReportRow} from "./UserRoleReportModel";
import CompanyUserRequired from "../../CompanyRequired";

@Component
export default class UserRoleReport extends CompanyUserRequired {
    @Inject()
    api!: Api;

    loading = false;
    items: UserRoleReportRow[] = [];

    async loadResult() {
        this.loading = true;
        try {
            this.items = await this.api.fetchUserRoleReport(this.company.orgNum);
        } catch (err) {
            this.emitError(err);
        } finally {
            this.loading = false;
        }
    }

    showUserUrl(personGuid: string) {
        return Routes.pages.useradmin(personGuid);
    }

    created() {
        this.loadResult();
    }
}
